var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import SwiperCore, { Keyboard, Mousewheel } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import arrow from '../../assets/images/BlogLandingHero/arrow.svg';
import parse from 'html-react-parser';
import './BlogLandingHero.scss';
import leftArrow from '../../assets/images/BlogLandingHero/leftArrow.svg';
import leftArrowDisabled from '../../assets/images/BlogLandingHero/leftArrowDisabled.svg';
import rightArrow from '../../assets/images/BlogLandingHero/rightArrow.svg';
import rightArrowDisabled from '../../assets/images/BlogLandingHero/rightArrowDisabled.svg';
import useViewport from '../../hooks/useViewport';
import { useOnScreen } from '../../hooks/useOnScreen';
import { ProgressIndicator } from '../ProgressIndicator/ProgressIdicator';
import { useLocation, useNavigate } from 'react-router-dom';
SwiperCore.use([Keyboard, Mousewheel]);
export var BlogLandingHero = function (_a) {
    var className = _a.className, data = _a.data, props = __rest(_a, ["className", "data"]);
    var BlogLandingHeroRef = useRef(null);
    var isOnScreenBlogLandingHero = useOnScreen(BlogLandingHeroRef, 0.9);
    var visualViewport = useViewport().visualViewport;
    var dummyScrollTopRef = useRef(null);
    var _b = useState(null), swiper = _b[0], setSwiper = _b[1];
    var _c = useState(0), activeSlide = _c[0], setActiveSlide = _c[1];
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var isDesktop = visualViewport.width >= 1024;
    var slideChangeHandler = function (swiper) {
        setActiveSlide(swiper.activeIndex);
        var currentSlideId = swiper === null || swiper === void 0 ? void 0 : swiper.slides[swiper.activeIndex].id;
        if (currentSlideId) {
            navigate(pathname + "#" + currentSlideId, { replace: true });
        }
    };
    var initSwiper = function (swiper) {
        setSwiper(swiper);
        var urlIds = window.location.href.split('#');
        var id = urlIds ? urlIds[urlIds.length - 1] : null;
        if (swiper && id !== null) {
            var target = swiper.slides;
            for (var i = 0; i < target.length; i++) {
                var ele = target[i];
                if (ele.id == id) {
                    swiper.slideTo(i);
                    break;
                }
            }
        }
    };
    var onLeftArrow = function () {
        swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
    };
    var onRightArrow = function () {
        swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
    };
    var LabelComponent = function (_a) {
        var data = _a.data;
        var labelDivs = data
            .map(function (item) { return item.label; })
            .filter(function (item) { return item; })
            .map(function (label) { return "<span>" + label.toUpperCase() + "</span>"; });
        var joinedLabels = labelDivs.join("<span className=\"blog-landing-hero-labels-slash\"> / </span>");
        return (_jsx("div", __assign({ className: "blog-landing-hero-labels" }, { children: parse(joinedLabels) }), void 0));
    };
    return (_jsxs("div", __assign({ className: "blog-landing-hero-main-container", ref: BlogLandingHeroRef }, { children: [_jsxs(Swiper, __assign({ modules: [Keyboard, Mousewheel], keyboard: {
                    enabled: true,
                    pageUpDown: true,
                    onlyInViewport: false,
                }, mousewheel: false, onSwiper: initSwiper, slidesPerView: "auto", centeredSlides: true, onSlideChange: slideChangeHandler, effect: "fade", speed: 300 }, { children: [_jsx("div", { className: "h-[1px] absolute top-0", slot: "container-start", id: "container-start", ref: dummyScrollTopRef }, void 0),
                    data.full_bleed_image_data.map(function (slide, i) { return (_jsx(SwiperSlide, __assign({ id: "slide-" + (i + 1) }, { children: _jsxs("div", __assign({ className: "blog-landing-hero-slide relative bg-white text-[#343741] " + (className || '') + " " + 'right-oriented' }, props, { children: [_jsxs("div", __assign({ className: "blog-landing-hero-text-container" }, { children: [_jsx(LabelComponent, { data: slide.eyebrow }, void 0),
                                        slide.headline && (_jsx("h2", __assign({ className: "blog-landing-hero-headline" }, { children: _jsx("a", __assign({ href: slide.cta.url, target: slide.cta.is_external ? '_blank' : '_self', rel: "noreferrer" }, { children: slide.headline }), void 0) }), void 0)),
                                        slide.body && (_jsx("div", __assign({ className: "blog-landing-hero-body" }, { children: _jsx("a", __assign({ href: slide.cta.url, target: slide.cta.is_external ? '_blank' : '_self', rel: "noreferrer" }, { children: parse(slide.body) }), void 0) }), void 0)),
                                        slide.date && (_jsx("div", __assign({ className: "blog-landing-hero-date" }, { children: slide.date }), void 0)),
                                        _jsx("div", __assign({ className: "blog-landing-hero-cta-container" }, { children: _jsx("ul", __assign({ className: "blog-landing-hero-cta-links" }, { children: _jsx("li", { children: _jsx("a", __assign({ href: slide.cta.url, target: slide.cta.is_external ? '_blank' : '_self', rel: "noreferrer" }, { children: _jsxs("p", __assign({ className: "blog-landing-hero-cta-label flex items-center text-[14px] leading-[1.71] font-bold text-[#005f9e]" }, { children: [_jsx("div", { children: slide.cta.title }, void 0),
                                                                _jsx("img", { className: "ml-[12px]", src: arrow, alt: "Arrow Icon" }, void 0)] }), void 0) }), void 0) }, void 0) }), void 0) }), void 0),
                                        isDesktop && data.full_bleed_image_data.length > 1 && (_jsxs("div", __assign({ className: "blog-landing-hero-carousel-indicators" }, { children: [_jsxs("div", __assign({ className: "blog-landing-hero-carousel-indicator-buttons" }, { children: [_jsx("button", __assign({ className: "z-10 relative", onClick: onLeftArrow, disabled: activeSlide === 0 }, { children: _jsx("img", { src: activeSlide === 0 ? leftArrowDisabled : leftArrow, style: {
                                                                    float: 'right',
                                                                }, alt: "left arrow" }, void 0) }), void 0),
                                                        _jsx("button", __assign({ className: "z-10 relative", onClick: onRightArrow, disabled: activeSlide === data.full_bleed_image_data.length - 1 }, { children: _jsx("img", { src: activeSlide ===
                                                                    data.full_bleed_image_data.length - 1
                                                                    ? rightArrowDisabled
                                                                    : rightArrow, alt: "right arrow" }, void 0) }), void 0)] }), void 0),
                                                _jsx(ProgressIndicator, { className: "blog-landing-hero-progress-indicator flex box-border justify-center items-center bottom-0 w-full relative  z-10", data: {
                                                        isOnScreen: isOnScreenBlogLandingHero,
                                                        array: data.full_bleed_image_data,
                                                        onClick: function (i) {
                                                            swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(i);
                                                        },
                                                        activeSlide: activeSlide,
                                                        showArrow: false,
                                                    } }, void 0)] }), void 0))] }), void 0),
                                _jsx("div", __assign({ className: "blog-landing-hero-slide-backdrop-container relative flex-shrink-0 w-screen max-w-full flex justify-center " + 'right-oriented' }, { children: _jsx("img", { src: slide.media, alt: "slide " + (i + 1) + " image" }, void 0) }), void 0)] }), void 0) }), "slide-" + i)); })] }), void 0),
            !isDesktop && data.full_bleed_image_data.length > 1 && (_jsx("div", __assign({ className: "blog-landing-hero-progress-indicator-container absolute flex box-border justify-center items-center bottom-0 w-full relative  z-10" }, { children: _jsx(ProgressIndicator, { className: " relative flex z-10 blog-landing-hero-progress-indicator-mobile-tablet", data: {
                        isOnScreen: isOnScreenBlogLandingHero,
                        array: data.full_bleed_image_data,
                        onClick: function (i) {
                            swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(i);
                        },
                        activeSlide: activeSlide,
                        showArrow: false,
                    } }, void 0) }), void 0))] }), void 0));
};
export default BlogLandingHero;
